import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const links = [
  { id: "cursos", label: "Cursos" },
  { id: "galeria", label: "Galería" },
  { id: "beneficios", label: "Beneficios" },
  { id: "testimonios", label: "Testimonios" },
  { id: "sucursales", label: "Sucursales" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    // Wait one tick for the mobile menu to collapse so target offset is correct
    setTimeout(() => scrollToSection(id), 80);
  };

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 nav-glass transition-all duration-500"
    >
      <div className="container-ie flex items-center justify-between h-14 md:h-20">
        <a
          href="/"
          data-testid="navbar-logo"
          className="flex items-center group shrink-0"
        >
          <img
            src="/assets/logo-europa.png"
            alt="Instituto Europa"
            className="h-9 md:h-12 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[0.78rem] font-semibold uppercase tracking-[0.18em] text-[#0a0a0a]/80 hover:text-[#c40000] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            data-testid="navbar-cta-enroll"
            onClick={() => go("contacto")}
            className="btn-primary"
          >
            Programar visita
          </button>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden nav-glass border-t border-black/5" data-testid="navbar-mobile-menu">
          <div className="container-ie py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-sm font-semibold uppercase tracking-[0.18em] text-[#0a0a0a]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="navbar-mobile-cta"
              onClick={() => go("contacto")}
              className="btn-primary mt-2 self-start"
            >
              Programar visita
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
